module.exports = __webpack_public_path__ + "img/masait_yes.975e5ade.png";